module.exports = __webpack_public_path__ + "static/img/download2.8a53656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/download2.png
// module id = KDMo
// module chunks = 1